import React from "react";
import { motion } from "framer-motion";
import * as analytics from "@/lib/analytics";

export default function LandingCTA({ onCTA }) {
  return (
    <section
      className="relative py-24 md:py-32 overflow-hidden"
      style={{ background: "#121212" }}
    >
      {/* Glow effect */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: "radial-gradient(ellipse 50% 60% at 50% 50%, rgba(215,255,55,0.06) 0%, transparent 70%)",
        }}
      />

      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-bold text-white mb-6"
          style={{ fontSize: "clamp(1.75rem, 3vw, 3rem)" }}
        >
          אל תחכו לשריקת הפתיחה. צרו מומנטום.
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="text-lg md:text-xl mb-10"
          style={{ color: "#FFFFFF" }}
        >
          העתיד של הגישה לאירועים כבר כאן, והוא שייך לכם.
        </motion.p>

        <motion.button
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          whileHover={{ scale: 1.05, boxShadow: "0 0 30px rgba(215,255,55,0.3)" }}
          whileTap={{ scale: 0.97 }}
          onClick={() => { analytics.trackCTA("footer_cta", { position: "footer" }); onCTA(); }}
          className="px-10 py-4 rounded-full font-bold text-lg cursor-pointer"
          style={{ background: "#D7FF37", color: "#121212" }}
        >
          הצטרפו ל-MOM3NTUM עכשיו
        </motion.button>
      </div>
    </section>
  );
}
